/**
 * The query keys shared between the reads in this folder and the cache writes
 * in `company-cache`.
 *
 * They live here rather than beside the query that owns each one because the
 * cache writes cross between them — deleting a team invalidates the member
 * lists — and importing a key from the query module directly would close an
 * import cycle and leave one side `undefined` at module init.
 */

// The companies list, which also carries the caller's own company user in each
// company (`myUsers`).
export const FETCH_COMPANIES_QUERY_KEY = 'fetchCompanies';

// The server-paginated users lists (members / team members / add-team modal).
export const FETCH_USERS_PAGINATED_QUERY_KEY = 'fetchUsersPaginated';

// The company-wide user counts (members, roles, licenses).
export const FETCH_USER_COUNTS_QUERY_KEY = 'fetchUserCounts';

// The company-wide team counts.
export const FETCH_TEAM_COUNTS_QUERY_KEY = 'fetchTeamCounts';

// The server-paginated teams list.
export const FETCH_TEAMS_PAGINATED_QUERY_KEY = 'fetchTeamsPaginated';

// A single team, keyed `[FETCH_TEAM_QUERY_KEY, teamId]`. Seeded by every list
// page so opening a team from the list needs no second request.
export const FETCH_TEAM_QUERY_KEY = 'fetchTeam';
